import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <button type="button" className={className} onClick={onClick}>
      <img src="img/icon/arrow.png" alt="prev" />
    </button>
  );
}
function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <button type="button" className={className} onClick={onClick}>
      <img src="img/icon/arrow.png" alt="next" />
    </button>
  );
}

function AdoptionPuppies() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          speed: 1000,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          speed: 1000,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          speed: 1000,
        },
      },
    ],
  };
  return (
    <section className="adoption-area-two pt-110 pb-110">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <div className="section-icon">
                <img src="img/icon/pawprint.png" alt="" />
              </div>
              <h5 className="sub-title">Conocé las mascotas</h5>
              <h2 className="title">Estos animalitos están esperando por ti</h2>
              <p>
                Muchos animales rescatados esperan una segunda oportunidad y
                necesitan tu ayuda. Al considerar hacer una donación, puedes
                brindarles atención veterinaria, alimentos y un refugio seguro.
                Además, si estás pensando en expandir tu familia, te invitamos a
                conocer a nuestros animales en adopción, listos para encontrar
                un hogar amoroso. También, si has visto animales perdidos en tu
                vecindario, ¡reportarlos puede ser crucial para reunirse con sus
                dueños! Juntos, podemos hacer una gran diferencia en la vida de
                estos animales.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container custom-container">
        <Slider className="row adopt-active" {...settings}>
          <div className="col-xl">
            <div className="adoption-item">
              <div className="adopt-thumb">
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }>
                  <img src="img/images/adop_img01.png" alt="" />
                </div>
                <span className="status">En Adopción</span>
              </div>
              <div className="adopt-content">
                <h3 className="title">
                  <div
                    onClick={() =>
                      window.open("https://www.galileopethouse.com/", "_blank")
                    }>
                    Nina
                  </div>
                </h3>
                <p>
                  Nina está buscando un hogar amoroso. Es una perrita muy
                  amigable. Accede a su perfil para conocer más sobre ella.
                </p>
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }
                  className="read-more">
                  Ver más <img src="img/icon/pawprint.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl">
            <div className="adoption-item">
              <div className="adopt-thumb">
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }>
                  <img src="img/images/adop_img02.png" alt="" />
                </div>
                <span className="status">Perdido</span>
              </div>
              <div className="adopt-content">
                <h3 className="title">
                  <div
                    onClick={() =>
                      window.open("https://www.galileopethouse.com/", "_blank")
                    }>
                    Tom
                  </div>
                </h3>
                <p>
                  Tom ha sido reportado cómo perdido cerca de dónde vives.
                  ¡Ayuda a su dueño y haz que Tom regrese a casa!
                </p>
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }
                  className="read-more">
                  Ver más <img src="img/icon/pawprint.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl">
            <div className="adoption-item">
              <div className="adopt-thumb">
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }>
                  <img src="img/images/adop_img03.png" alt="" />
                </div>
                <span className="status">Rescatado</span>
              </div>
              <div className="adopt-content">
                <h3 className="title">
                  <div
                    onClick={() =>
                      window.open("https://www.galileopethouse.com/", "_blank")
                    }>
                    Husky
                  </div>
                </h3>
                <p>
                  Husky fue rescatado y necesita donaciones para su atención.
                  ¡Ayuda a Husky!
                </p>
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }
                  className="read-more">
                  Ver más <img src="img/icon/pawprint.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl">
            <div className="adoption-item">
              <div className="adopt-thumb">
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }>
                  <img src="img/images/adop_img04.png" alt="" />
                </div>
                <span className="status">Encontrado</span>
              </div>
              <div className="adopt-content">
                <h3 className="title">
                  <div
                    onClick={() =>
                      window.open("https://www.galileopethouse.com/", "_blank")
                    }>
                    Luna
                  </div>
                </h3>
                <p>
                  Luna ha sido encontrada recientemente y quiere volver con sus
                  dueños. Ayuda a Luna!
                </p>
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }
                  className="read-more">
                  Ver más <img src="img/icon/pawprint.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl">
            <div className="adoption-item">
              <div className="adopt-thumb">
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }>
                  <img src="img/images/adop_img05.png" alt="" />
                </div>
                <span className="status">En Adopción</span>
              </div>
              <div className="adopt-content">
                <h3 className="title">
                  <div
                    onClick={() =>
                      window.open("https://www.galileopethouse.com/", "_blank")
                    }>
                    Beto
                  </div>
                </h3>
                <p>
                  Beto es un perrito muy cariñoso que busca un hogar amoroso.
                  ¡Adóptalo!
                </p>
                <div
                  onClick={() =>
                    window.open("https://www.galileopethouse.com/", "_blank")
                  }
                  className="read-more">
                  Ver más <img src="img/icon/pawprint.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
}

export default AdoptionPuppies;
